export default __webpack_public_path__ + "static/hepato-zasilvat-dr-stoinov-0e956ad1623ebba59d338077dbe86e71.jpg";